import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';


@Injectable()
export class AuthAdminGuard  {


	constructor(
		private router: Router,
		private authService: AuthenticationService
	) {}


	canActivate() {

		if( !this.authService.isAdmin() ) {

			console.warn( "AUTH-ADMIN-GUARD user not admin" );
			this.router.navigate( ['auth/login'] );
			return false;

		}

		return true;
	}

}
